import React, { useState } from "react";
import OrderActions from "./OrderActions";
import { ORDER_PAYMENT_STATUS } from "constants/order";
import { stations_location } from "constants/order";
import { ORDER_TYPE } from "constants/order";
import { PRODUCT_CATEGORIES } from "constants/order";
import {
  Text,
  CustomerText,
  PriceText,
  DateText,
} from "components/DataTableText";
import OrderService from "services/order";
import { SelectText } from "components/DataTableText";
// import { OrderService } from "services/order";

const OrderStatusCell = ({ value, options, translation, id }) => {
  const [valueOrder, setValueOrder] = useState(value);

  const status = React.useMemo(
    () =>
      Object.values(stations_location).find((el) => el.value === valueOrder),
    [valueOrder]
  );

  return (
    <SelectText
      defaultValue={valueOrder}
      options={options}
      onUpdate={(newStatus) => {
        OrderService.updateOrder({
          id: id,
          data: {
            orderStatus: newStatus,
            note: " ",
          },
        });
        setValueOrder(newStatus);
      }}
      translation={translation}
      textClass={`status ${status?.color || "text-medium"}`}
      textValue={
        translation(status?.label) || translation("orderStatus.pending")
      }
    />
  );
};

const OrderPaymentCell = ({ value, options, translation, id }) => {
  const [valueOrder, setValueOrder] = useState(value);

  const status = React.useMemo(
    () =>
      Object.values(ORDER_PAYMENT_STATUS).find((el) => el.value === valueOrder),
    [valueOrder]
  );
  return (
    <SelectText
      defaultValue={valueOrder}
      options={options}
      onUpdate={(newStatus) => {
        OrderService.updateOrder({
          id: id,
          data: {
            paymentStatus: newStatus,
            note: " ",
          },
        });
        setValueOrder(newStatus);
      }}
      translation={translation}
      textClass={`status ${status?.color || "text-warning"}`}
      textValue={
        translation(status?.label) || translation("orderPaymentStatus.new")
      }
    />
  );
};

export const getColumns = (translation, history, refetch, categories = []) => {
  const orderStatusOptions = Object.values(stations_location).map((item) => ({
    label: translation(item.label),
    value: item.value,
  }));
  const orderPaymentOptions = Object.values(ORDER_PAYMENT_STATUS).map(
    (item) => ({
      label: translation(item.label),
      value: item.value,
    })
  );
  return [
    {
      title: translation("order.id"),
      dataIndex: "orderId",
      key: "id",
      width: 50,
      align: "center",
      render: (id) => (
        <span
          onClick={() => history.push(`/order-detail/${id}`)}
          className="order-index"
        >
          {id}
        </span>
      ),
    },
    {
      title: translation("order.totalAmount"),
      dataIndex: "totalAmount",
      key: "totalAmount",
      width: 120,
      align: "center",
      render: (totalAmount) => (
        <PriceText className="order-amount" price={totalAmount} />
      ),
    },
    {
      title: translation("order.customer"),
      dataIndex: "customer",
      key: "customer",
      width: 150,
      align: "center",
      render: (_, record) => (
        <CustomerText
          firstName={record?.firstName}
          phoneNumber={record?.phoneNumber}
          email={record?.email}
        />
      ),
    },
    {
      title: translation("product.category"),
      dataIndex: "productCategory",
      key: "productCategory",
      width: 150,
      align: "center",
      showOnBar: true,
      filterType: "select",
      filterOptions: categories.map((category) => ({
        label: category.productCategoryName || category.categoryName || category.name,
        value: category.productCategoryId || category.categoryId || category.id,
      })),
      render: (_, record) => {
        const orderItems = record.orderItems || [];
        if (orderItems.length === 0) return translation("product.uncategorized");
        
        const getCategoryName = (item) => {
          const { productCategory, productType } = item;
          if ([6, 7, 8].includes(productCategory)) {
            return PRODUCT_CATEGORIES[productCategory]?.label;
          }
          if (productCategory) {
            const cat = categories.find(c => 
              (c.productCategoryId || c.categoryId || c.id) === productCategory
            );
            if (cat) return cat.productCategoryName || cat.categoryName || cat.name;
          }
          return productType || null;
        };
        
        const displayNames = [...new Set(
          orderItems.map(getCategoryName).filter(Boolean)
        )];
        const displayText = displayNames.length > 0 
          ? displayNames.join(", ") 
          : translation("product.uncategorized");
        
        return (
          <div
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden'
            }}
            title={displayText}
          >
            {displayText}
          </div>
        );
      },
    },
    {
      title: translation("order.paymentStatus"),
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      width: 120,
      align: "center",
      showOnBar: true,
      filterType: "select",
      filterOptions: ORDER_PAYMENT_STATUS.map((item) => ({
        label: translation(item.label),
        value: item.value,
      })),
      render: (paymentStatus, record) => {
        return (
          <OrderPaymentCell
            value={paymentStatus}
            options={orderPaymentOptions}
            translation={translation}
            id={record?.orderId}
          />
        );
      },
    },
    {
      title: translation("order.orderStatus"),
      dataIndex: "orderStatus",
      key: "orderStatus",
      width: 120,
      align: "center",
      showOnBar: true,
      filterType: "select",
      filterOptions: stations_location.map((item) => ({
        label: translation(item.label),
        value: item.value,
      })),
      render: (orderStatus, record) => {
        return (
          <OrderStatusCell
            value={orderStatus}
            options={orderStatusOptions}
            translation={translation}
            id={record?.orderId}
          />
        );
      },
    },
    {
      title: translation("order.createdAt"),
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      align: "center",
      filterType: "date",
      render: (date) => <DateText className="order-date" date={date} />,
    },
    {
      title: translation("order.action"),
      dataIndex: "action",
      key: "action",
      width: 180,
      align: "left",
      render: (_, record) => <OrderActions record={record} refetch={refetch} />,
    },
  ];
};
